import { useEffect, useState } from "react";
import { MessageCircle, Mail, Headset } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, Loading, cardCls } from "@/components/mobile/parts";
import { useAuth } from "@/context/AuthContext";
import { api, waLink } from "@/lib/api";
import { cn } from "@/lib/utils";

export default function MSupport() {
  const { session } = useAuth();
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/platform-info").then((r) => setInfo(r.data)).catch(() => setInfo({})); }, []);
  const msg = `Olá! Preciso de ajuda no FSCsistemas. Empresa: ${session.tenant.nome_fantasia} · Chave de acesso: ${session.tenant.access_number} · Usuário: ${session.user.name}`;
  return (
    <>
      <MTopBar title="Suporte e Atendimento" back />
      <MPage>
        <div className={cn(cardCls, "space-y-2 p-5 text-center")}>
          <Headset className="mx-auto h-10 w-10 text-[#1565c0]" />
          <p className="font-display text-lg font-semibold">Como podemos ajudar?</p>
          <p className="text-sm text-slate-500">Ao chamar o suporte, informe a sua chave de acesso <b className="font-mono">{session.tenant.access_number}</b>.</p>
        </div>
        {!info ? <Loading /> : (
          <>
            {info.support_whatsapp && <Button asChild className="h-12 w-full bg-[#16a34a] text-white hover:bg-[#15803d]"><a href={waLink(info.support_whatsapp, msg)} target="_blank" rel="noreferrer" data-testid="m-support-whatsapp"><MessageCircle className="mr-2 h-5 w-5" />Falar pelo WhatsApp</a></Button>}
            {info.support_email && <Button asChild variant="outline" className="h-12 w-full"><a href={`mailto:${info.support_email}?subject=${encodeURIComponent("Suporte FSCsistemas")}&body=${encodeURIComponent(msg)}`} data-testid="m-support-email"><Mail className="mr-2 h-5 w-5" />{info.support_email}</a></Button>}
            {!info.support_whatsapp && !info.support_email && <p className="rounded-xl bg-slate-200 p-3 text-center text-sm" data-testid="m-support-none">Os contatos do suporte ainda não foram cadastrados. Fale com o administrador do sistema.</p>}
          </>
        )}
      </MPage>
    </>
  );
}
